function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBilancia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C6991"
    },
    d: "M341.525,105.174c0-9.574-7.762-17.336-17.336-17.336H188.966c-9.574,0-17.336,7.762-17.336,17.336 v69.345c0,9.574,7.762,17.336,17.336,17.336h135.223c9.574,0,17.336-7.762,17.336-17.336V105.174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#528FB3"
    },
    d: "M255.999,87.837h-67.034c-9.574,0-17.336,7.184-17.336,16.758v69.345 c0,9.574,7.762,17.914,17.336,17.914h67.034V87.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M463.81,0H48.189c-9.105,0-16.406,7.049-16.406,16.154v13.364c0,42.517,34.51,77.967,77.029,77.967 h294.377c42.518,0,77.029-35.451,77.029-77.967V16.154C480.216,7.049,472.915,0,463.81,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F4F5"
    },
    d: "M255.999,0H48.189c-9.105,0-16.406,7.049-16.406,16.154v13.364c0,42.517,34.51,77.967,77.029,77.967 h147.188V0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#16A5D9"
    },
    d: "M466.067,478.574l-25.172-310.747c-1.277-15.763-14.667-27.981-30.481-27.981H101.586 c-15.814,0-29.204,12.219-30.481,27.983L45.933,478.638c-0.688,8.486,2.228,17.098,8,23.358S67.897,512,76.411,512h359.176 c8.514,0,16.708-3.778,22.479-10.038C463.838,495.703,466.755,487.058,466.067,478.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4AD0FF"
    },
    d: "M255.999,139.847H101.586c-15.814,0-29.204,12.219-30.481,27.983L45.933,478.638 c-0.688,8.486,2.228,17.098,8,23.358C59.705,508.255,67.897,512,76.411,512h179.588V139.847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCCCCC"
    },
    d: "M255.439,285.666L255.439,285.666c74.584,0,135.048,60.462,135.048,135.047v18.475H120.392v-18.474 C120.392,346.129,180.854,285.666,255.439,285.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1E1E1"
    },
    d: "M255.439,285.666L255.439,285.666h0.561v153.521H120.392v-18.474 C120.392,346.129,180.854,285.666,255.439,285.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FB5858"
    },
    d: "M207.733,360.7c-7.316,6.176-8.239,17.403-2.062,24.719l45.154,53.768h45.38l-64.043-76.137 C225.988,355.736,215.05,354.522,207.733,360.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF835D"
    },
    d: "M207.733,360.7c-7.316,6.176-8.239,17.403-2.062,24.719l45.154,53.768h5.174l-0.001-47.8 l-23.835-28.337C225.988,355.736,215.05,354.522,207.733,360.7z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilancia);
export default __webpack_public_path__ + "static/media/bilancia.03be7350cf0043d8e7eacf2f8d0b6a53.svg";
export { ForwardRef as ReactComponent };